/* eslint-disable react/require-default-props */
import React from 'react';

import HeaderConlicitaseg from 'components/organisms/header_conlicitaseg';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import HeaderDefault from './header_default';

interface HeaderProps {
  offlineMode?: boolean;
}

/** O usuário exclusivo do ConlicitaSeg tem topo próprio, sem os menus e notificações do Conlicitação. */
const HeaderNew = ({ offlineMode }: HeaderProps) => {
  const isOnlyConlicitaseg = useOnlyConlicitaseg();

  if (isOnlyConlicitaseg && !offlineMode) return <HeaderConlicitaseg />;

  return <HeaderDefault offlineMode={offlineMode} />;
};

export default HeaderNew;
